export default __webpack_public_path__ + "static/icon-phone-5be709504812c9639a958fdade908247.png";